import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function Web3Page() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Your Partner in the <span className="bg-gradient-to-r from-blue-400 via-cyan-500 to-purple-500 bg-clip-text text-transparent">Evolution of the Internet</span></>}
        description="We guide your brand through the exciting world of Web3, blockchain, and the metaverse, turning innovation into tangible growth."
        bgImage="/assets/futuristic-web3-metaverse.png"
        primaryBtn={{ text: "Explore Opportunities", link: "/contact", icon: "ri-rocket-line" }}
        secondaryBtn={{ text: "View Portfolio", link: "/work", icon: "ri-external-link-line" }}
      />

      <Section>
        <FeatureGrid 
          title="Guidance for the Next Digital Era"
          subtitle="Discover how our specialized consultation services can prepare your brand for the exciting frontiers of Web3."
          items={[
            { title: 'Metaverse Strategy', description: 'Establish meaningful presence in virtual worlds.', icon: 'ri-vr-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'NFT Minting', description: 'Create unique digital assets & campaigns.', icon: 'ri-nft-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Blockchain Consult', description: 'Integration & decentralized applications.', icon: 'ri-links-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Trend Analysis', description: 'Stay ahead of emerging tech.', icon: 'ri-telescope-line', color: 'from-blue-500 to-cyan-500' }
          ]}
          columns={2}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="From Hype to Opportunity"
          subtitle="Our approach is built on thorough research and strategic foresight to effectively integrate Web3."
          steps={[
            { title: 'Research', description: 'Market & tech dive.', icon: 'ri-search-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Analysis', description: 'Feasibility check.', icon: 'ri-bar-chart-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Strategy', description: 'Roadmap creation.', icon: 'ri-lightbulb-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Implementation', description: 'Tech integration.', icon: 'ri-tools-line', color: 'from-blue-500 to-cyan-500' },
            { title: 'Evolution', description: 'Future adaptation.', icon: 'ri-rocket-line', color: 'from-blue-500 to-cyan-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Ready to Pioneer the <span className="bg-gradient-to-r from-blue-400 to-cyan-500 bg-clip-text text-transparent">Future?</span></>}
        description="Don't let your brand get left behind. Our expert consultation positions you at the forefront of digital innovation."
        primaryBtn={{ text: "Web3 Consultation", link: "/contact" }}
        secondaryBtn={{ text: "Success Stories", link: "/work" }}
        stats={[
          { number: '50+', label: 'Projects' },
          { number: '25+', label: 'Integrations' },
          { number: '100%', label: 'Future-Ready' },
          { number: '24/7', label: 'Support' }
        ]}
      />

      <Footer />
    </div>
  );
}